






import { Vue, Component, Prop } from 'vue-property-decorator'
import { State, Mutation, Action } from 'vuex-class'
@Component
export default class ZwlTabItem extends Vue {
  @Prop({ default: () => { return {} } }) tab!: object
  @Prop({ default: 'tab' }) type!: string
  @State activeTab
  get active () {
    return this.activeTab.id === this.tab['id']
  }
  
  get themeColor () {
    return '#' + (this.$route.query.pageColor || '3bb4d7')
  }
  
  searchContent: string = ''
  @Mutation setActiveTab
  @Action getTabArticle
  @Action getSearchArticle
  
  changeTab () {
    if (this.type === 'search') {
      this.setActiveTab({})
      this.$Modal.confirm({
        render: (h) => {
          return h('Input', {
            props: {
              value: this.searchContent,
              autofocus: true,
              placeholder: '请输入搜索的内容...'
            },
            on: {
              input: (val) => {
                this.searchContent = val
              }
            }
          })
        },
        onOk: () => {
          this.getSearchArticle(this.searchContent)
        }
      })
    }
    if (!this.active) {
      this.setActiveTab(this.tab)
      this.getTabArticle()
    }
  }
}
